<template>
  <div class="zweigi">
    <div class="columns">
        <div class="column">
            <h1>Login.</h1>
            <v-text-field label="E-Mail Adresse" v-model="mail" outlined hide-details :rules="[rules.required, rules.email]"></v-text-field>
            <v-divider></v-divider>
            <v-text-field v-model="pass" :append-icon="show1 ? eye : eyeOff" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Passwort" hint="Midestens 8 Zeichen" @click:append="show1 = !show1" outlined></v-text-field>
            <v-btn block outlined @click="login()" color="#2ecc71">Login</v-btn>
        </div>
        <div class="column">
            <h1>Registrierung.</h1>
            <v-alert type="info">Hierzu müssen Sie sich auf der Whitelist befinden.</v-alert>
            <v-divider></v-divider>
            <v-text-field label="Vorname" v-model="vorname" outlined hide-details :rules="[rules.required]"></v-text-field>
            <v-divider></v-divider>
            <v-text-field label="Nachname" v-model="nachname" outlined hide-details :rules="[rules.required]"></v-text-field>
            <v-divider></v-divider>
            <v-text-field label="E-Mail Adresse" v-model="mailr" outlined hide-details :rules="[rules.required, rules.email]"></v-text-field>
            <v-divider></v-divider>
            <v-text-field v-model="passr" :append-icon="show1 ? eye : eyeOff" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Passwort" hint="Midestens 8 Zeichen" @click:append="show1 = !show1" outlined></v-text-field>
            <v-btn block outlined @click="register()" color="#2ecc71">Registrieren</v-btn>
        </div>
    </div>
    <v-snackbar v-model="snackbar">{{error}}
        <v-btn color="red" text @click="snackbar = false">Schließen</v-btn>
    </v-snackbar>
  </div>
</template>

<style scoped>

</style>

<script>
import { fb } from '../db'
import { db } from '../db'
import { mdiEye } from '@mdi/js'
import { mdiEyeOff } from '@mdi/js'

const autoren = db.collection('shared').doc('autoren');
const whitelist = db.collection('vault').doc('whitelist');

export default {
    mounted(){
      this.$Progress.finish()
      if(fb.auth().currentUser != null) {
        this.$router.push('/')
       }
    },
    methods: {
        login: function(){
            fb.auth().signInWithEmailAndPassword(this.mail, this.pass).catch((error) => {
                    this.error = error.message
                    this.snackbar = true
            }).then(() => {
                    if(fb.auth().currentUser != null && this.$route.path !== '/') {
                        this.$router.push('/')
                    }})
        },
        checkUser: function(){
            if(fb.auth().currentUser != null) {
                return true
            }
            return
        },
        register: function(){
            whitelist.get().then((whitelist) => {
                var whitelist = whitelist.data().whitelist
                if(whitelist != null && whitelist.includes(this.mailr)) {
                    autoren.get().then((data) => {
                    var update = data.data()
                    if(typeof update == 'undefined' || update == null) {
                        update = {}
                        update.autoren = []
                    }
                    fb.auth().createUserWithEmailAndPassword(this.mailr, this.passr).then((user) => {
                        if(fb.auth().currentUser != null && this.$route.path !== '/') {
                            if(typeof update.autoren.find((x) => x.mail == this.mailr) == 'undefined') {
                                update.autoren.push({mail: this.mailr, vorname: this.vorname, nachname: this.nachname})
                                autoren.set({autoren: update.autoren})
                            }
                            this.auth = true
                            this.$router.push('/')
                    }}).catch((error) => {
                        this.error = error.message
                        this.snackbar = true
                    })
                    })
                } else {
                    this.error = "Kein solcher Eintrag auf der Whitelist."
                    this.snackbar = true
                }
            })
        }
    },
    data: () => ({
        mail: "",
        pass: "",
        code: "",
        mailr: "",
        snackbar: false,
        error: "",
        passr: "",
        eye: mdiEye,
        vorname: "",
        nachname: "",
        eyeOff: mdiEyeOff,
        show1: false,
        rules: {
          required: value => !!value || 'Benötigt.',
          min: v => v.length >= 8 || 'Mindestens 8 Zeichen.',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalide E-Mail.'
          }
        }
    })
}
</script>